import { Icon24GoToMainComponent } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const GoToMainComponentIconLocal: SvgComponent = ({ title, ...props }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    {title ? <title>{title}</title> : null}
    <path
      d="M12.5 3C12.7761 3 13 3.22386 13 3.5V8.5C13 8.77614 12.7761 9 12.5 9C12.2238 9 12 8.77614 12 8.5V4.70703L3.85348 12.8535C3.65822 13.0488 3.34171 13.0488 3.14645 12.8535C2.95118 12.6583 2.95118 12.3417 3.14645 12.1465L11.2929 4H7.49996C7.22382 4 6.99996 3.77614 6.99996 3.5C6.99996 3.22386 7.22382 3 7.49996 3H12.5Z"
      fill="currentColor"
    />
  </svg>
);

/** "Jump to the source of this thing" — e.g. the tool's parent workflow. */
export const GoToMainComponentIcon = fplIcon(GoToMainComponentIconLocal, Icon24GoToMainComponent);
